import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { DeleteLookupsRequest, DeleteLookupsResponse, GetLookupsRequest, GetLookupsResponse, LookupsByTypeRequest, LookupsByTypeResponse, LookupsChildrenRequest, LookupsChildrenResponse, LookupsIsAllowedRequest, LookupsIsAllowedResponse, PatchLookupsRequest, PatchLookupsResponse, PostLookupsRequest, PostLookupsResponse, PutLookupsRequest, PutLookupsResponse } from './types/TLookupsServices';

const URL_Prefix = '/lookups';

export const lookupsService = createApi({
    reducerPath: 'lookupsService',
    baseQuery: getBaseQuery,
    tagTypes: ['Lookups'],
    endpoints: (builder) => ({
        getLookups: builder.query<GetLookupsResponse, GetLookupsRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        postLookups: builder.mutation<PostLookupsResponse, PostLookupsRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Lookups'],
        }),
        patchLookups: builder.mutation<PatchLookupsResponse, PatchLookupsRequest>({
            query: ({ uuid, ...body }) => ({
                url: `${URL_Prefix}/${uuid}/`,
                method: 'PATCH',
                body: body,
            }),
            invalidatesTags: ['Lookups'],
        }),
        lookupsIsAllowed: builder.mutation<LookupsIsAllowedResponse, LookupsIsAllowedRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/is_allowed/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Lookups'],
        }),
        getLookupsType: builder.query<LookupsByTypeResponse, LookupsByTypeRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/by_types/`,
                method: 'GET',
                params: params,
            }),
        }),
        getChildren: builder.query<LookupsChildrenResponse, LookupsChildrenRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/children/`,
                method: 'GET',
                params: params,
            }),
        }),
        putLookups: builder.mutation<PutLookupsResponse, PutLookupsRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PUT',
                body: body,
            }),
            invalidatesTags: ['Lookups'],
        }),
        deleteLookups: builder.mutation<DeleteLookupsResponse, DeleteLookupsRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Lookups'],
        }),
        importFromFile: builder.mutation<void, { file: File }>({
            query: (body) => {
                const formData = new FormData();
                formData.append('file', body.file);

                return {
                    url: `${URL_Prefix}/import_from_file/`,
                    method: 'POST',
                    body: formData,
                    headers: {
                    },
                };
            },
            invalidatesTags: ['Lookups'],
        }),
    }),
});

export const {
    useGetLookupsQuery,
    useGetLookupsTypeQuery,
    useLazyGetLookupsQuery,
    useLazyGetLookupsTypeQuery,
    useLookupsIsAllowedMutation,
    usePatchLookupsMutation,
    usePostLookupsMutation,
    usePutLookupsMutation,
    useDeleteLookupsMutation,
    useGetChildrenQuery,
    useLazyGetChildrenQuery,
    useImportFromFileMutation
} = lookupsService;